import { ProductOrderViewModel } from '@models/productOrderView';
import { create } from 'zustand';
import { PaymentStatementModalStore } from './paymentStatementModalStore';

const refundModeModalStore = create<PaymentStatementModalStore>((set, get) => ({
  show: false,
  data: undefined,
  close: () => {
    const isCloseExecute = !!get().show;
    set({ show: false });
    return isCloseExecute;
  },
  open: (data?: ProductOrderViewModel) => {
    set({ data: data, show: true });
  },
}));

export default refundModeModalStore;
